export default __webpack_public_path__ + "static/P_SearchThumb_Evocam-560e8a1db3088b9e92362a8425aa8ac9.webp";